import React from "react"

const LoadingSkeleton = () => {
	return (
		<div className="px-4 py-6 relative">
			<div className="mb-6 bg-gray-100 p-4 rounded-lg animate-pulse">
				<div className="h-8 bg-gray-200 rounded w-3/4 mb-2"></div>
				<div className="h-6 bg-gray-200 rounded w-1/2"></div>
			</div>

			<div className="flex items-center justify-between mb-6">
				<div className="w-2/3 h-10 bg-gray-200 rounded animate-pulse"></div>
				<div className="w-1/4 h-10 bg-gray-200 rounded animate-pulse"></div>
			</div>

			<div className="bg-white rounded-lg relative">
				<div className="flex bg-gray-100 p-4 rounded-t-lg min-h-[70px]">
					<div className="w-1/6 h-8 bg-gray-200 rounded animate-pulse"></div>
					<div className="w-5/6 h-8 bg-gray-200 rounded animate-pulse ml-2 flex-grow"></div>
				</div>

				{[1, 2, 3].map(i => (
					<div key={i} className="flex p-4 border-t border-gray-100">
						<div className="w-1/6 h-24 bg-gray-200 rounded animate-pulse"></div>
						<div className="w-5/6 h-24 bg-gray-200 rounded animate-pulse ml-2"></div>
					</div>
				))}
			</div>
		</div>
	)
}

export default LoadingSkeleton
